import { Component } from '@angular/core';

@Component({
  selector: 'app-printpreview',
  imports: [],
  templateUrl: './printpreview.component.html',
  styleUrl: './printpreview.component.css'
})
export class PrintpreviewComponent {

}
